/*
 *
 * User actions
 *
 */

import * as actions from "./constants";

export function hydrateLocations(locations) {
  return {
    type: actions.HYDRATE_LOCATIONS,
    data: locations,
  };
}
